<template>
  <el-dialog
    title="关闭询单"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="closeDialog"
    width="500px"
    class="close-inquiry">
    <div class="tip">
      <i style="color: #F56C6C;">*</i>
      <span class="txt">请选择并输入关闭原因，确认后供应商可查看关闭询单的原因。</span>
    </div>
    <el-radio-group v-model="form.closeType">
      <template v-for="item in closeTypeList">
        <el-radio v-if="item.value !== 'BLOCK_AFTER_VIOLATION' || ![2, 2].includes(inquireSource)" :label="item.value" :key="item.value">
          <span class="radio-label">{{ item.label }}</span>
          <el-input v-if="['CLOSE', 'CANCEL', 'OTHER'].includes(form.closeType) && form.closeType === item.value" v-model.trim="form.closeReason" placeholder="请输入关单原因" style="width: 368px;"></el-input>
        </el-radio>
      </template>
    </el-radio-group>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { closeInquiry } from '@/api/RFQ';
export default {
  data () {
    return {
      visible: false,
      closeTypeList: [
        {
          label: '询单完成',
          value: 'FINISH',
        },
        {
          label: '询单关闭',
          value: 'CLOSE',
        },
        // {
        //   label: '询单取消',
        //   value: 'CANCEL',
        // },
        // {
        //   label: '其他',
        //   value: 'OTHER',
        // },
        {
          label: '严重违反平台规则，拉入黑名单',
          value: 'BLOCK_AFTER_VIOLATION',
        },
      ],
      inquireSource: '',
      form: {
        id: '',
        closeType: 'FINISH',
        closeReason: '',
      },
    };
  },
  watch: {
    'form.id' (val) {
      if (val) {
        this.form.closeType = 'FINISH';
      }
    },
  },
  methods: {
    closeDialog () {
      this.visible = false;
    },
    async confirm () {
      if (!this.form.id) return;
      if (['CLOSE', 'CANCEL', 'OTHER'].includes(this.form.closeType) && !this.form.closeReason) {
        this.$message.warning('请填写关单原因');
        return;
      }
      await closeInquiry(this.form);
      this.closeDialog();
      this.$emit('refresh');
    },
  },
};
</script>
<style lang="scss" scoped>
.close-inquiry {
  .tip {
    padding: 5px 0;
    display: flex;
    align-items: baseline;
    .txt {
      padding: 0 5px;
    }
  }
  /deep/.el-radio {
    padding: 0 20px;
    height: 35px;
    display: flex;
    align-items: center;
  }
  .radio-label {
    display: inline-block;
    width: 60px;
  }
}
</style>
